import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from '../api-base.service';
import {
  AdminSupportCasesPageView,
  AdminSupportCountsView,
  SupportChannel,
  SupportMessageView,
  SupportStatus,
  SupportThreadView,
} from 'src/app/common/models/support/admin-support.models';

export interface GetCasesParams {
  status: SupportStatus;
  channel?: SupportChannel;
  waitingOnUs?: boolean;
  needsAdminReview?: boolean;
  member?: string;
  page?: number;
  pageSize?: number;
}

@Injectable({ providedIn: 'root' })
export class AdminSupportApiService {
  private readonly basePath = '/api/admin/support';

  constructor(private apiBaseService: ApiBaseService) {}

  getCounts(): Observable<AdminSupportCountsView> {
    return this.apiBaseService.get<AdminSupportCountsView>(`${this.basePath}/counts`, [], null);
  }

  getCases(params: GetCasesParams): Observable<AdminSupportCasesPageView> {
    const queryParams: Record<string, string> = { status: params.status };
    if (params.channel) queryParams['channel'] = params.channel;
    if (params.waitingOnUs !== undefined) queryParams['waitingOnUs'] = String(params.waitingOnUs);
    if (params.needsAdminReview !== undefined) queryParams['needsAdminReview'] = String(params.needsAdminReview);
    if (params.member) queryParams['member'] = params.member;
    if (params.page !== undefined) queryParams['page'] = String(params.page);
    if (params.pageSize !== undefined) queryParams['pageSize'] = String(params.pageSize);
    return this.apiBaseService.getWithParams(`${this.basePath}/cases`, queryParams);
  }

  getThread(supportId: string): Observable<SupportThreadView> {
    return this.apiBaseService.get<SupportThreadView>(`${this.basePath}/cases/${supportId}`, [], null);
  }

  reply(supportId: string, message: string): Observable<SupportMessageView> {
    return this.apiBaseService.create<SupportMessageView>(`${this.basePath}/cases/${supportId}/reply`, null, { message });
  }

  close(supportId: string): Observable<unknown> {
    return this.apiBaseService.create<unknown>(`${this.basePath}/cases/${supportId}/close`, null, {});
  }
}
